export let faq = [
    {
        question: 'Co to jest Score rating?',
        ansver: 'Score rating - to personalny wskaźnik niezawodności jako potencjalnego kredytobiorcy, w oparciu o historię kredytową. My wliczamy różne czynniki w pięciu obszarach w celu ustalenia zdolności kredytowej: historia płatności, aktualny poziom zadłużenia, rodzaj wykorzystanych kredytów, długość historii kredytowej oraz nowe kredyty. Użytkownicy posiadający wysoką ocenę zdolności kredytowej łatwiej uzyskają kredyt oraz zazwyczaj uzyskują najlepsze warunki pożyczki. Użytkownikom z niskim wynikiem Score rating trudniej uzyskać kredyt, ale korzystając ze wskazówek ekspertów, można dowiedzieć się, jak poprawić swoją historię kredytową, a tym samym podnieść wynik Score rating.' 
    },
    {
        question: 'Skąd biorą się dane w raporcie?',
        ansver: 'Informacja kredytowa w BIK pochodzi od instytucji finansowych. Zgłaszają one w BIK wszystkie informacje na temat limitów kredytowych, terminów, bieżących zobowiązań oraz zmian dotyczących danych osobowych kredytobiorcy. Dla otrzymania score rate, RacoonGo sprawdza ocenę punktową BIK i raport KRD i na podstawie tych danych bada zdolność kredytową kredytobiorcy oraz przygotowuje sprawozdania dla każdego użytkownika i zapewnia szeroki wybór ofert kredytowych.'
    },
    {
        question: 'Jak sprawdzić raport w BIK za darmo?',
        ansver: 'Dla naszych nowych użytkowników oferujemy pierwszy darmowy raporty BIK.' 
    },
    {
        question: 'Jak często informacje są aktualizowane w BIK i KRD?',
        ansver: 'W systemie BIK i KRD dane są aktualizowane po każdym ubieganiu się o kredyt potencjalnego kredytobiorcy i po spłacie zadłużenia (na czas lub z opóźnieniem).' 
    },
    {
        question: 'Jakie informacje otrzymam w raporcie?',
        ansver: 'Twoje dane osobowe i informacje o Twoim kredycie, w tym: data przyznania, rodzaj kredytu – np. kredyt hipoteczny, ilość i kwoty płatności, waluta itd. Użytkownik otrzyma również raporty na temat spłat kredytów. Mogą to być zarówno pozytywne informacje (płatność rat na czas), jak i negatywne (opóźnienia).' 
    },
    {
        question: 'Czy możesz usunąć swoją historię kredytową w BIK?',
        ansver: 'Usunięcie historii kredytowej polega na usunięciu danych z rejestru BIK. Niestety, jest to niemożliwe.' 
    },
]


// WEBPACK FOOTER //
// src/js/controllers/serviceContent/faq.js